import { createI18n } from 'vue-i18n'
import type { App } from 'vue'

// Import language files
import en from './locales/en.json'
import th from './locales/th.json'

// Get saved locale from localStorage or use default
// Note: Can't use useLocalStorage here as Vue instance not created yet
// The saving is handled by @core/components/I18n.vue using useLocalStorage
const savedLocale = localStorage.getItem('app-locale') || 'th'

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: savedLocale, // Use saved locale
  fallbackLocale: 'en',
  messages: {
    en,
    th,
  },
  globalInjection: true,
})

// Watch for locale changes and save to localStorage
i18n.global.locale.value = savedLocale

export default function (app: App) {
  app.use(i18n)
}

export { i18n }
